export const InteractionMethods = {
    EasyReferral: 'Easy Referral',
    PhysicianServices: 'Physician Services',
};
